import React from "react";
import {
  Modal,
  Select,
  DatePicker,
  Radio,
  InputNumber,
  TreeSelect,
} from "antd";
import moment from "moment";
const { Option, OptGroup } = Select;

export const CarryForwadModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
}) => {
  const assetTypeGroups = [
    {
      label: "Standard Investments",
      options: [
        "Stock",
        "Mutual Fund",
        "ETF (Exchange-Traded Fund)",
        "Bond",
        "Cryptocurrency",
      ],
    },
    {
      label: "Real Estate",
      options: [
        "Primary Residence",
        "Rental Property",
        "Investment Property (Undeveloped Land)",
        "REIT (Real Estate Investment Trust)",
      ],
    },
    {
      label: "Business-Related",
      options: ["Private Business Interest", "Stock Options"],
    },
    {
      label: "Special Tax Treatment",
      options: [
        "Collectibles",
        "Precious Metals",
        "Qualified Small Business Stock (QSBS)",
      ],
    },
    {
      label: "Miscellaneous",
      options: ["Other"],
    },
  ];

  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{title}</h3>
        </div>
        <div
          style={{
            maxHeight: "25rem",
            overflow: "scroll",
            paddingRight: "0.5rem",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Source/Asset Sold <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="Source/Asset"
              name="asset"
              value={data && data.asset}
              id="asset"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Asset Type</h3>
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="-Select Asset Type-"
              value={data && data.assetType}
              onChange={(value) => handleChange("assetType", value)}
            >
              {assetTypeGroups.map((group) => (
                <OptGroup key={group.label} label={group.label}>
                  {group.options.map((item) => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
                </OptGroup>
              ))}
            </Select>
          </div>

          {/* Commission and Fees */}
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Commission and Fees</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                className="Input"
                placeholder="Commission and Fees"
                name="commissionAndFees"
                value={data && data.commissionAndFees}
                onChange={(value) => handleChange("commissionAndFees", value)}
              />
            </div>
          </div>

          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Date Purchase</h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Date"
              name="purchaseDate"
              value={data && data.purchaseDate && moment.utc(data.purchaseDate)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("purchaseDate", date);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Purchase Price</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                // formatter={(value) =>
                //   ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Purchase Price"
                name="purchasePrice"
                value={data && data.purchasePrice}
                id="purchasePrice"
                onChange={(value) => {
                  handleChange("purchasePrice", value);
                }}
              />
            </div>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Date Sold</h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Date Sold"
              name="saleDate"
              value={data && data.saleDate && moment.utc(data.saleDate)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("saleDate", date);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Sale Price</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                // formatter={(value) =>
                //   ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Sale Price"
                name="salePrice"
                value={data && data.salePrice}
                id="salePrice"
                onChange={(value) => {
                  handleChange("salePrice", value);
                }}
              />
            </div>
          </div>

          {/*<div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Short Term/Long Term</h3>
            <Select
              showSearch
              placeholder="-Select-"
              value={data && data.term}
              onChange={(value, id) => {
                console.log("value", value);
                handleChange("term", value);
              }}
            >
              {["Short Term", "Long Term"].map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Capital Gain</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                // formatter={(value) =>
                //   ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Capital Gain"
                name="capitalGain"
                value={data && data.capitalGain}
                id="capitalGain"
                onChange={(value) => {
                  handleChange("capitalGain", value);
                }}
              />
            </div>
          </div> */}
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.asset}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
